import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {OnboardingMenuItemModule} from '../../pages/onboarding-page/onboarding-menu-item';
import {L10nModule} from '../translate';
import {
    MainMenuDropdownCustomItemRendererDirective
} from './main-menu-dropdown/main-menu-dropdown-custom-item-renderer.directive';
import {MainMenuDropdownComponent} from './main-menu-dropdown/main-menu-dropdown.component';
import {MainMenuDummyComponent} from './main-menu-dummy.component';
import {MainMenuStaticComponent} from './main-menu-static/main-menu-static.component';
import {MainMenuComponent} from './main-menu.component';

@NgModule({
    imports: [
        CommonModule,
        L10nModule,
        RouterModule,
        OnboardingMenuItemModule,
        MainMenuDropdownCustomItemRendererDirective
    ],
    declarations: [
        MainMenuComponent,
        MainMenuStaticComponent,
        MainMenuDropdownComponent,
        MainMenuDummyComponent
    ],
    exports: [
        MainMenuComponent,
        MainMenuDummyComponent
    ]
})
export class MainMenuModule {}
